export enum OrderStatus {
  COMPLETED = 'Terminado',
  IN_PROGRESS = 'En proceso',
  CANCELED = 'Cancelado',
  NEW = 'Nuevo',
}
